<script lang="ts">
    export let color:'primary'|'secondary' = 'primary';
</script>

<div class="LinearProgress" class:LinearProgress--secondary={color === 'secondary'} />

<style type="text/scss">
    @import "../../scss/config.scss";
    .LinearProgress {
        position: relative;
        height: 5px;
        width: 100%;
        overflow: hidden;
        background: lighten($color-primary, 50%);
        &:before,
        &:after {
            content: "";
            position: absolute;
            display: block;
            height: 5px;
            background: $color-primary;
        }
        &:before {
            animation: LinearProgressIncrease 2s infinite;
        }
        &:after {
            animation: LinearProgressDecrease 2s 0.5s infinite;
        }

        &--secondary {
            background: lighten($color-secondary, 50%);
            &:before,
            &:after {
                background: $color-secondary;
            }
        }
    }

    @keyframes LinearProgressIncrease {
        from {
            left: -5%;
            width: 5%;
        }
        to {
            left: 130%;
            width: 100%;
        }
    }

    @keyframes LinearProgressDecrease {
        from {
            left: -80%;
            width: 80%;
        }
        to {
            left: 110%;
            width: 10%;
        }
    }
</style>
